import React from 'react';

/**
 * Reusable Mini Dashboard Component for Module Pages
 * Displays key metrics in a compact card format
 */
function MiniDashboard({ title, stats, bgColor = '#2b3380', icon = '📊' }) {
  return (
    <div className="bg-white rounded-lg shadow-md p-4 mb-6">
      <h2 className="text-lg font-bold mb-4 flex items-center" style={{ color: bgColor }}>
        <span className="mr-2">{icon}</span> {title}
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="rounded-lg p-4 text-white shadow-sm hover:shadow-md transition-shadow"
            style={{ backgroundColor: stat.color || bgColor }}
          >
            <p className="text-xs font-medium opacity-90 mb-1">{stat.label}</p>
            <p className="text-2xl font-bold">{stat.value}</p>
            {stat.subtitle && (
              <p className="text-xs opacity-75 mt-1">{stat.subtitle}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default MiniDashboard;
